/*
    Description: card gui interface
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/
// main class
class Cards{

    // class constructor
    constructor({
        cardGUIClass = null,
        cardWrapperClass = null,
        rightBttnClass = null,
        leftBttnClass = null,
        dragClass = null,
        hideClass = null,
        cardClass = null,
    }={}){

        // get wrapper class
        this.wrapperClass = cardWrapperClass;

        // get cardClass
        this.cardClass = cardClass;

        // card gui
        this.gui = document.querySelector(`.${cardGUIClass}`);

        // card wrapper
        this.cardsWrapper = document.querySelector(`.${this.wrapperClass}`);

        // get cards
        this.cards = (this.cardsWrapper) ? this.cardsWrapper.querySelectorAll(`.${this.cardClass}`) : document.querySelectorAll(`.${this.cardClass}`); 

        // get bttn
        this.rightBttn = (this.gui) ? this.gui.querySelector(`.${rightBttnClass}`) : null;
        this.leftBttn = (this.gui) ? this.gui.querySelector(`.${leftBttnClass}`) : null;

        // timer
        this.timer = null;

        // delay in seconds 
        this.delay = 0.25;

        // drag class
        this.drag = dragClass;

        // hide class
        this.hide = hideClass;

        // set debug switch
        this.debug = false;

        // init direction
        this.direction = "right";

        // drag status
        this.dragStatus = false,

        // init drag position
        this.startDragPosition = 0;

        // init 
        this.startScrollPosition = 0;

        // click status
        this.clicked = false;

        // current click
        this.click = 0;

        // hide overflow
        this.overflow = "--js-card-control";

        // init current window width
        this.winWidth = window.innerWidth;

        // run events
        this.events();

    }   

    // events
    events(){
        
        // run events for specific gui only
        if(!this.gui) return;

        // check GUI visibility on page load
        this.guiVisibility();
        
        // resize event
        window.addEventListener("resize", this.debounce.bind(this));

        // buttons
        if(this.leftBttn) this.leftBttn.addEventListener("touchstart", this.clickedLeftBttn.bind(this), {passive:false});
        if(this.leftBttn) this.leftBttn.addEventListener("click", this.clickedLeftBttn.bind(this));
        if(this.leftBttn) this.leftBttn.addEventListener("keyup", this.hitKeys.bind(this));
        if(this.rightBttn) this.rightBttn.addEventListener("touchstart", this.clickedRightBttn.bind(this), {passive:false});
        if(this.rightBttn) this.rightBttn.addEventListener("click", this.clickedRightBttn.bind(this));
        if(this.rightBttn) this.rightBttn.addEventListener("keyup", this.hitKeys.bind(this));
        
        // touch
        // this.dragDomUpdate();
        // if(this.cardsWrapper) this.cardsWrapper.addEventListener("touchstart", this.startDrag.bind(this), {passive:false});
        // if(this.cardsWrapper) this.cardsWrapper.addEventListener("touchmove", this.dragging.bind(this), {passive:false});
        // if(this.cardsWrapper) this.cardsWrapper.addEventListener("touchend", this.stopDrag.bind(this), {passive:false});

        // init
        for(const card of this.cards){
            card.addEventListener("touchstart", this.startDrag.bind(this), {passive:false});
            card.addEventListener("touchmove", this.dragging.bind(this), {passive:false});
            card.addEventListener("touchend", this.stopDrag.bind(this), {passive:false});
        }

        // iOS Fix - add new event listener for card 
        this.newDomEventListener();

        // wait for transistions
        if(this.cardsWrapper) this.cardsWrapper.addEventListener('transitionend', this.switch.bind(this));
        if(this.cardsWrapper) this.cardsWrapper.addEventListener('webkitTransitionEnd', this.switch.bind(this));
        if(this.cardsWrapper) this.cardsWrapper.addEventListener('mozTransitionEnd', this.switch.bind(this));
        if(this.cardsWrapper) this.cardsWrapper.addEventListener('msTransitionEnd', this.switch.bind(this));
        
        // on focus
        if(this.cardsWrapper) document.addEventListener('keyup', this.tabLayoutFix.bind(this));

    }

    // iOS Fix - add new event listener for card 
    newDomEventListener(){
        
        // end case
        if(!this.cardsWrapper) return;

        // Create a new MutationObserver instance
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {

                // Do something when the DOM changes
                if(mutation.type == 'childList'){

                    // get new dom element
                    const domElement = mutation.addedNodes[0]; 

                    // add event listners
                    domElement.addEventListener("touchstart", this.startDrag.bind(this), {passive:false});
                    domElement.addEventListener("touchmove", this.dragging.bind(this), {passive:false});
                    domElement.addEventListener("touchend", this.stopDrag.bind(this), {passive:false});

                    // update gui visibilty
                    this.guiVisibility();

                }

            });

        });
        
        // observer config options
        const config = { 
            // attributes:true,
            childList:true,
            subtree:true
        };
        
        // observe target node
        observer.observe(this.cardsWrapper, config);
        
        // stop observing
        // observer.disconnect();

    }

    // left bttn click
    clickedLeftBttn(e){
        
        // prevent default
        e.preventDefault();
        
        // prevent click spam
        if(this.clicked) return;

        // decrement click
        this.click = (this.click > 0) ? (this.click-1) : 0;

        // set direction
        this.direction = "left";

        // move
        this.move();

    }
    
    // right bttn click
    clickedRightBttn(e){

        // prevent default
        e.preventDefault();
        
        // prevent click spam
        if(this.clicked) return;

        // increment click
        this.click++;

        // set direction
        this.direction = "right";        
        
        // move
        this.move();


    }

    // debouncing for window resize
    debounce(){

        // get current width 
        let currentWinWidth = window.innerWidth; 

        // check if width is different 
        if(currentWinWidth !== this.winWidth){

            // update window width
            this.winWidth = window.innerWidth;

            // clear the timeout
            clearTimeout(this.timer);

            // run settimeout method
            this.timer = setTimeout(this.guiVisibility(), this.delay);

        }

    }

    // show/hide gui
    guiVisibility(){
        
        // end case
        if((!this.cardsWrapper)||(!this.gui)||(this.gui.children.length <= 0)) return;
        
        // reset
        this.reset();

        // get card values
        const vals = this.getValues();
        
        // check if total card(s) width is more than wrapper width - if so show gui otherwise hide gui
        (vals.total > vals.parent) ? this.gui.children[0].classList.remove(this.hide) : this.gui.children[0].classList.add(this.hide);

        // return
        return;

    }

    // calculate card values
    getValues(){

        // end case
        if(!this.cardsWrapper) return 0;

        // update wrapper and cards selector
        this.cardsWrapper = document.querySelector(`.${this.wrapperClass}`);
        this.cards = this.cardsWrapper.querySelectorAll(`.${this.cardClass}`); 

        // init wrapper
        const wrapperW = this.cardsWrapper.getBoundingClientRect()['width'],

        // get main wrapper padding offset
        padding = (window.getComputedStyle(this.cardsWrapper)["paddingLeft"].split("px")[0] * 1),

        // get gap offset
        gap = (window.getComputedStyle(this.cardsWrapper)["gap"].split("px")[0] * 1),

        // get position locations
        coordinates = [];

        // init card width
        let cardsTotal = 0;

        // LOOP: thru cards
        for(const card of this.cards){

            // get card left position 
            const cardXPos = card.offsetLeft,

            // get card width
            cardWidth = card.getBoundingClientRect()['width'];

            // add card width to total 
            cardsTotal += (cardWidth + gap);

            // add coordinates
            coordinates.push([cardXPos, (cardXPos + cardWidth), cardWidth]);

        }

        // add parent margin and padding offset 
        cardsTotal += padding;

        // set final output
        const output = {parent:wrapperW, total:(cardsTotal - gap), gap:gap, padding:padding, count:this.cards.length, coord:coordinates};

        // debug
        if(this.debug) console.log("GET VALUE METHOD >>> return output:", output);

        // return values
        return output;

    }

    move(){

        // tablayout fix - reset overflow
        // this.cardsWrapper.classList.remove(this.overflow);
        this.removeOverflow(this.cardsWrapper, this.overflow);

        // get card values 
        let vals = this.getValues(),

        // init card count
        cardCount = 0,

        // init total visible card widths 
        cardWidthLimit = 0,

        // init visible shift distance (visible container within parent)
        shiftDistance = vals.padding,

        // get old position
        oldPosition = (this.cardsWrapper) ? Math.floor((this.cardsWrapper.style.left.replace("px", "") * 1)) : null;

        // make sure we have card to move
        if(vals.count <= 0) return;

        // LOOP
        for(const card of vals.coord){

            // add to limit
            cardWidthLimit += (card[2] + vals.gap);

            // kill loop
            if(cardWidthLimit >= vals.parent) break;

            // distance traveled
            shiftDistance += (card[2] + vals.gap);

            // add to card count
            cardCount++;

        }

        // make sure we are at least 1 card
        if(cardCount <= 0) cardCount = 1

        // card count start 0
        const cardNum = vals.count - 1,
        
        // set final slide resting position
        endXPosition = -(vals.coord[cardNum][1] - (vals.parent - vals.padding)),

        // shift
        shiftCount = Math.floor(vals.total/shiftDistance),

        // get max click 
        maxClick = (shiftCount > cardNum) ? cardNum : shiftCount,

        // move positions
        xMove = vals.coord[cardCount * this.click];

        // force this click to be at our max
        if(this.click >= maxClick) this.click = maxClick;

        // ------------------------------------------------------------------------------------- //
        // any this.click reliant stuff needs to be below this line ---------------------------- //
        // ------------------------------------------------------------------------------------- //
        // move to furthest position (very end)
        if(!xMove || -(xMove[0]) <= endXPosition){
            
            // if we are moving to a new spot clicked is true
            if(oldPosition != Math.floor(endXPosition)) this.clicked = true;

            // update DOM element
            this.cardsWrapper.style.left = `${endXPosition}px`;
            
        // move normal
        }else{
            
            // if we are the very first position move to padding
            if(this.click <= 0){

                // if we are moving to a new spot clicked is true
                if(oldPosition != 0) this.clicked = true;

                // update DOM element
                this.cardsWrapper.style.left = `0px`;

            // keep sliding
            }else{

                // get new position
                const newPosition = -(xMove[0] - vals.gap);

                // if we are moving to a new spot clicked is true
                if(oldPosition != Math.floor(newPosition)) this.clicked = true;

                // update DOM element
                this.cardsWrapper.style.left = `${newPosition}px`;

            }

        }

        // debug
        if(this.debug) console.log("this.clicked:", this.clicked, "click:", this.click, "shift distance:", shiftDistance, "card count:", cardCount, vals, endXPosition, (Math.abs(endXPosition)/shiftDistance));
        
        // return
        return;

    }

    // start drag
    startDrag(e){

        // prevent 
        e.preventDefault();

        // NO DRAG: check for link click
        if((e.target.tagName.toLowerCase() === "a") && e.target.hasAttribute('href')){

            // js mouse click
            e.target.click();            

            // return
            return;

        };

        // remove overflow 
        this.removeOverflow(this.cardsWrapper, this.overflow);

        // dragging: set drag status 
        this.dragStatus = true;
        
        // add drag class
        if(this.cardsWrapper) this.cardsWrapper.classList.add(this.drag);
        
        // set x position
        this.startDragPosition = (e.touches[0]) ? e.touches[0].pageX : null;

        // set current scroll position
        this.startScrollPosition = (this.cardsWrapper) ? Math.abs(this.cardsWrapper.offsetLeft) : null;
        
        // debug
        if(this.debug) console.log("start drag...");
        
    }

    // dragging
    dragging(e){

        // prevent 
        e.preventDefault();

        // if drag did not start dont start dragging
        if(!this.dragStatus) return;

        // get current drag position
        const currentDragPosition = ((e.touches[0]) ? e.touches[0].pageX : null),
        
        // get new position
        newScrollPos = (currentDragPosition) ? (this.startScrollPosition - (currentDragPosition - this.startDragPosition)) : null,

        // get padding
        padding = (window.getComputedStyle(this.cardsWrapper)["paddingLeft"].split("px")[0] * 1),

        // limit
        limit = (this.cardsWrapper.scrollWidth - this.cardsWrapper.offsetWidth) + (this.mobileDeviceCheck() ? padding : 0);

        // right most border
        if((newScrollPos <= 0 || newScrollPos) >= limit){
            
            // reset position
            this.cardsWrapper.style.left = `${-(limit)}px`;            

            // set drag status 
            this.dragStatus = false;
            
            // return
            return;
        
        }

        // left most border
        if(-(newScrollPos) >= 0){

            // set drag status 
            this.dragStatus = false;

            // reset position
            this.cardsWrapper.style.left = `0px`;

            // return
            return;

        }

        // update card position
        this.cardsWrapper.style.left = `${-(newScrollPos)}px`;
        
        // debug
        if(this.debug) console.log("dragging...");
        
    }

    // enter slides
    hitKeys(e){

        // prevent default
        e.preventDefault();

        // get keyboard value
        const keyed =  e.keyCode || e.key.toLowerCase(),
        
        // get bttn 
        bttn = e.target,

        // get current button class list
        classes = (bttn) ? bttn.classList : null;

        // check 
        if(classes){

            // make sure we hitting enter - and move
            if(keyed === 13 || keyed === "enter") (classes[1] && (classes[1].indexOf("left") !== -1)) ?  this.clickedLeftBttn(e) : this.clickedRightBttn(e);
            
        };

        // return
        return;

    }

    // test
    // tabLayoutFix(state = null, e){
    tabLayoutFix(e){

        // stop bubbling
        e.stopPropagation();

        // get parent warpper 
        const parent = e.target.closest(`.${this.wrapperClass}`), 
        
        // get target
        target = e.target.closest(`.${this.cardClass}`),
        
        // get active element
        element = (target) ? (document.activeElement || target.contains(document.activeElement)) : null; 

        // check and remove class hidden overflow
        if(parent == null) return this.removeOverflow(this.cardsWrapper, this.overflow);
        
        // add overflow to prvent tab layout shift
        if(element !== null) parent.classList.add(this.overflow); 

        // return
        return;

    }
    
    // remove overflow
    removeOverflow(element = null, className = null){

        // end case
        if(element === null || className === null) return;

        // return -- remove class from element
        return element.classList.remove(className);

    }

    // stop drag
    stopDrag(e){
        
        // prevent 
        e.preventDefault();
        
        // dragging: set drag status 
        this.dragStatus = false;
        
        // remove drag class
        if(this.cardsWrapper) this.cardsWrapper.classList.remove(this.drag);
        
        // debug
        if(this.debug) console.log("drag stopped...");
        
    }

    //switch
    switch(){
        
        // prevent click spam
        this.clicked = false;
        
        // debug
        if(this.debug) console.log("this.clicked has been set to false now...");

    }

    // reset
    reset(){

        // reset cards position 
        if(this.cardsWrapper) this.cardsWrapper.style.left = `0px`; 

        // reset clicks
        if(this.click) this.click = 0;

        // reset overflow
        this.removeOverflow(this.cardsWrapper, this.overflow);

        // debug
        if(this.debug) console.log("cardwrapper left position and this.click has been set to 0...");

    }

    // mobile device check
    mobileDeviceCheck(){
        
        // init
        let check = false;

        // crazy regex
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        
        // return
        return check;
        
    }

}

// export module
export default Cards;
